module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d12e187"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Morr_ISBNXXXXXXXXX_epub_c4_r1#d12e83",
      "id": "d12e189"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e191"
    }
  }, [_vm._v("A soft but persistent touch on her lips brought Gervase Howard out of sleep instantly. Opening her eyes, she saw Mr. Bob staring at her. Smiling, she stroked the head of the huge cat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e193"
    }
  }, [_vm._v("“Good morning, Mr. Bob. How are you this morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e195"
    }
  }, [_vm._v("The cat at once began to purr, the rumbles deep in his chest humming as if generated by a miniature engine. He rose at once, arched his back, and yawned mightily. Placing his front paws on Gervase’s chest, he began kneading her powerfully, eyes half shut with pleasure. The purring reached a crescendo, and although the claws of the cat were painful, Gervase did not object.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e197"
    }
  }, [_vm._v("“You’ve been fighting again, Mr. Bob. Why do you have to do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e199"
    }
  }, [_vm._v("Mr. Bob was a dark-gray tabby with a large blunt head marked with a dark "), _c('i', [_vm._v("M")]), _vm._v("and scarred from many battles. The only white spot on him was at the tip of his tail, and when he held it up straight, it always reminded Gervase of a candle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e204"
    }
  }, [_vm._v("For a time Gervase lay there, shutting out everything except the cat. She stroked Mr. Bob as he continued to knead her chest; then finally she pulled him down, rolling over so she could face him. He had big golden eyes, round as shillings, and he watched her carefully, still purring.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e206"
    }
  }, [_vm._v("“You’re all I have left, Mr. Bob.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e208"
    }
  }, [_vm._v("The whispered words frightened Gervase, and her vivid imagination suddenly began to function despite her attempts to will the world away. Ever since the funeral, she had tried to blot out the details of her future, but now, graphically and powerfully, she could see her mother’s face as it had looked in the wooden coffin—pale, worn, completely different from the way she had appeared in life. Gervase closed her eyes but the image seemed to magnify itself. She clutched Mr. Bob tightly and forced herself to think of her mother as she liked to remember her best. A series of images flashed in front of her—her mother smiling and laughing, her blue-green eyes dancing. Gervase remembered a time when she had come to her mother hurt and frightened—she could not even recall why now—and her mother had simply picked her up and spun around until Gervase was dizzy. Then she had pulled Gervase onto her lap and held her tightly, whispering comfort.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e210"
    }
  }, [_vm._v("That poignant memory triggered others like it, for Gervase’s mother had always known how to give comfort to her only daughter. Sometimes she had quoted Scripture, always with a fervency and a faith that Gervase had never seen in anyone else.At other times she had sung happy songs to Gervase, sometimes popular songs but more often hymns they sang together in the Methodist chapel they attended every Sunday. Often she would tell Gervase fantastic stories filled with wonder and hope. Somehow she had always been able to drive away Gervase’s fears and anxieties.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e212"
    }
  }, [_vm._v("The memories were jolted and driven away as Mr. Bob began to protest. He stiffened his legs and squirmed, saying, “Yow! ” —which meant, as Gervase well knew, “It’s time to turn me loose.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e215"
    }
  }, [_vm._v("She released her grip and the big cat sat up and began washing his face. Then he gave himself a complete bath. Enviously Gervase thought, "), _c('i', [_vm._v("I wish I had no more worries than you have, ")]), _c('i', [_vm._v("Mr. Bob. ")]), _vm._v("But she did not dwell on this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e222"
    }
  }, [_vm._v("Throwing back the worn coverlet, she stepped out of the bed and stood for a moment, dreading the day. Then she dressed hurriedly, putting on her one good dress—the one she had worn to the funeral—and moved to the oak washstand. Slowly she washed her face and then, looking into the small mirror, brushed her hair. As always, for a moment she stared at herself, disliking what she saw, for she felt plain and homely. She had a thin face dominated by large blue-green eyes she had inherited from her mother.\n Her hair\n was light blond and came down well below her shoulders. There was a slight curl in it, and she quickly bound it up so it made a bun on the back of her head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e224"
    }
  }, [_vm._v("She looked down at herself, frowning, for at the age of fifteen she was very thin indeed. She knew other girls her age who had already blossomed into womanly contours. Another memory of her mother, whispering to her, "), _c('i', [_vm._v("“You’re going to be a ")]), _c('i', [_vm._v("beautiful young girl. Right now you are like one of the colts you see out ")]), _c('i', [_vm._v("in the pasture—all legs and awkward. But that will pass.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e232"
    }
  }, [_vm._v("Gervase quickly turned away and moved into the other room. Her only hope for beauty was that her mother had been a well-shaped woman with winsome features. "), _c('i', [_vm._v("If I could only be as ")]), _c('i', [_vm._v("pretty as Mum!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e238"
    }
  }, [_vm._v("She halted abruptly and stared at the calendar her mother had made: a single sheet of paper with the weeks set out in pencil. Gervase touched it, sadness welling up as she remembered her mother urging her to draw birds at the top for decoration. She ran her fingers over the year, 1851, and the scrolled word "), _c('i', [_vm._v("May. ")]), _vm._v("She stopped at the number 5 and her throat grew thick—for she had circled the number when she came home from her mother’s funeral.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e243"
    }
  }, [_vm._v("Turning to avoid the calendar, she blinked back the tears and looked around the room. This was the only home she had ever known, and she was saddened further at the thought that this was the last day she would spend in it. There were only the two rooms, the bedroom and this one, the larger, which served for all other purposes. Two windows at one end of the room let in the feeble sunlight that illuminated it. She stared at the walls she had helped her mother paper. The wall covering had been salvaged from the dump—evidently, a wealthy patron had had too much. It featured small bluebirds and thrushes singing their hearts out. She had a painful memory of the day they had pasted the paper on, and she immediately moved toward the wood stove which served for both heat and cooking. The rest of the furniture included a pine table and four chairs—none of which matched—a settee, and beside it a lamp. A bookcase made of boxes was now empty, for Gervase had given away most of the books, keeping only a few. She had spent the week since the funeral getting rid of things, giving some of them away, selling some for what she could get, and now the room looked bare and alien—not at all like the warm, cheerful place in which she had grown up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e245"
    }
  }, [_vm._v("Deliberately pushing these thoughts from her mind, Gervase built a fire. She was very efficient at this and soon it was blazing. She had given away all the groceries to Mrs. Warden, who had a houseful of youngsters, retaining only enough for this final breakfast. She fried the last of the bacon and the one thin slice of ham, but when she sat and tried to eat, the food seemed to stick in her throat. When she picked up the last of the bread she had saved, the thought came to her, "), _c('i', [_vm._v("This was the last loaf of bread Mum ")]), _c('i', [_vm._v("ever made. ")]), _vm._v("The thought so distressed her that she quickly put the bread down and wiped her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e252"
    }
  }, [_vm._v("Mr. Bob came to press against her leg, and she broke the rest of the ham into small fragments and set it down. She watched as he wolfed the morsels down eagerly, then looked up and said, “Yow!” —which meant, “More, please!” Gervase snatched him and pressed her face against his fur, whispering, “That’s. . . that’s all there is, Mr. Bob, but I’m sure we’ll have plenty for you in our new place.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e254"
    }
  }, [_vm._v("The thought of a new place disturbed Gervase and she got up at once. Picking up the bread, she went out the back door and began dividing the bread and tossing the crumbs on the ground. Quickly birds began to gather, mostly sparrows that were so tame now, they came almost close enough to take the bread out of her hand. It was a daily ritual for her, and had been so for so long that she could not remember when it first began. The birds chirped and made cheerful noises, scuffling in the dust and battling over the crumbs. “You don’t have to fight. There’s plenty today.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e256"
    }
  }, [_vm._v("As she broke off bits of bread and tossed them on the ground, she lifted her head. This was the sight most familiar to her: a long line of identical houses jammed together so closely that one could scarcely squeeze between them. They ran in a curving circle down a hill, and all had clotheslines out back, most of them containing garments swaying in the breeze like lazy ghosts. Children were out now in a few of the yards, and she could hear their voices as they shouted and laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e258"
    }
  }, [_vm._v("It was a poor enough section of the small village. Almost all the inhabitants of the poorly painted houses worked in the garment mill. Smoke was rising in ragged gray streams from the chimneys of the dwellings, scoring the sky, which seemed clear of clouds for the first time this May.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e261"
    }
  }, [_vm._v("There was nothing beautiful about the scene, yet Gervase Howard almost cried out as she realized that this would be the last day she would see it.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "0310246997_content_0013_006",
      "id": "d12e263",
      "src": "images/0310246997_content_0013_006.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e264"
    }
  }, [_vm._v("“Gervase? There you are, darlin’!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e266"
    }
  }, [_vm._v("Agnes Warden noted that Gervase was wiping furtively at her eyes, and felt a quick pang of pity. Gervase’smother had been Agnes’sc losest friend, and the heavyset woman was sad as she approached and stood before the young girl. Shifting her two-week-old baby girl to a more comfortable position, she said, “We’re going to miss you so much, Gervase—especially Betsy here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e268"
    }
  }, [_vm._v("Gervase took the baby, cuddled her and touched her cheek, watching the bubbles that rose from the red lips. “I’ll miss you, too, Miss Agnes, and . . . and the children.” Misery was written across her face. “Oh, I wish I could stay here!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e270"
    }
  }, [_vm._v("Mrs. Warden made a comforting noise as she hugged her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e272"
    }
  }, [_vm._v("“You’ll be much better off with your uncle and aunt, luv. Everybody needs family, and it’s a fine place where they live, a in’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e274"
    }
  }, [_vm._v("“I guess so. I don’t know them, Miss Agnes.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e276"
    }
  }, [_vm._v("The woman wanted to say something to comfort the young girl but nothing came. She had always loved Charlotte Howard and this daughter of hers, and the death had hit her hard indeed. Death was common enough in this place but it was never easy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e278"
    }
  }, [_vm._v("“I miss Mama, Miss Agnes!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e280"
    }
  }, [_vm._v("“Why, of course you do! You wouldn’t be a good girl if you didn’t —but the Lord took her to himself, dearie, and he’s given you a home. You’ll have your uncle and aunt to love you, and you’ll make many friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e283"
    }
  }, [_vm._v("Gervase handed the infant back. “The vicar is supposed to come and pick me up very soon, so I’ll say goodbye now.” She threw her arms around the woman, whispering, “Goodbye, Miss Agnes.” Then she kissed the baby. “Goodbye, Betsy. Be a good girl.” Agnes watched sadly as Gervase turned and walked blindly away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e285"
    }
  }, [_vm._v("For a long moment Agnes stared after the slight form of the young girl; then she turned and walked slowly back toward her own house. She was greeted by Bertha Willington, a tall, thin woman who lived in the house next to hers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e287"
    }
  }, [_vm._v("“How’s she taking it, dearie?” Bertha asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e289"
    }
  }, [_vm._v("“She’s bleeding in her ’e art, she is, but there’s nothing else for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e291"
    }
  }, [_vm._v("“Wot about the aunt, the one she’sa-going to? Is she a good ’un?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e293"
    }
  }, [_vm._v("“Oh, I never met her, and Gervase only met her once, years ago. But Charlotte said as ’ow she was a good woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e295"
    }
  }, [_vm._v("“They wasn’t too close, was they?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e297"
    }
  }, [_vm._v("“No. They lived too far apart, but she’s quick, Gervase is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e299"
    }
  }, [_vm._v("She’ll make a place for ’er self.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e301"
    }
  }, [_vm._v("“But I’ll miss the both of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e303"
    }
  }, [_vm._v("“So will I. She’sa dear child!”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "0310246997_content_0015_009",
      "id": "d12e306",
      "src": "images/0310246997_content_0015_009.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e307"
    }
  }, [_vm._v("“Whoa, Geraldine, stop now! Do you hear me?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e309"
    }
  }, [_vm._v("The Reverend Gerald Howells tugged at the reins and brought the brown mare to a stop. She shook her head rebelliously and would have gone on, but Howells jerked the lines again, saying, “That’s enough, now! You’re too blasted ambitious!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e311"
    }
  }, [_vm._v("Reverend Howells sat very still in the small buggy, considering\n the task that lay before him.\n It had been a hard thing, the funeral of Charlotte Howard, as it always was when a child was left an orphan. Howells had developed a great affection for Mrs. Howard, for she was a faithful member of the church. She had little money to spare, but anytime there was work to be done or a case of need, she was always ready to give what help she could. The funeral had been better attended than he expected. He was surprised to discover how many friends Charlotte Howard had made in her brief lifetime. Her husband had died not long after they were married, and now there was only the child Gervase. It was to this problem that the minister now gave his thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e313"
    }
  }, [_vm._v("Howells was not an impulsive man by any means. He liked his sermons well planned, as he liked everything else. It disturbed him when routines were broken, and often before a difficult interview he would go over what he planned to say. Now his lips moved as he reviewed the speech he had been working on. The mare’sears twitched, though she was accustomed to her master’s soliloquies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e315"
    }
  }, [_vm._v("“Now, my dear Gervase, this has been very hard for you, ” Howells whispered. “You and your mother were so close—and with no father, even closer. I know your grief has been almost unbearable. But you must put that behind you, child, and I thank God that you have an uncle and an aunt who are willing to take you in. From all reports, they are respectable and good people indeed. Their invitation was most warm and you will have a good home. You will be lonely but that’s only natural. Now you must look forward. Treasure your mother’s dear memory, but she would want you to be happy in your new place.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e317"
    }
  }, [_vm._v("For a moment Howells sat wondering how his speech would be received by the child, but he could do no better. Securing the reins, he stepped off the buggy and gave the mare a pat. “There, Geraldine, you behave yourself.” Then he moved toward the house. He was a long, limber man and a busy one. This task of seeing Gervase safely embarked was the chore he had most on his mind this day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e319"
    }
  }, [_vm._v("When Howells knocked on the door, it opened almost at once, and he smiled and took off his hat. “Good morning, Gervase.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e321"
    }
  }, [_vm._v("“Good morning, Vicar.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e323"
    }
  }, [_vm._v("“I came a little early so I might help you take care of any chores remaining.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e325"
    }
  }, [_vm._v("“Everything is ready. I’m all packed. Come in, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e328"
    }
  }, [_vm._v("As the vicar stepped inside, he glanced around the room. It was a poor enough place, as were all the houses on the Row, but everything was clean and neat. He nodded. “The new tenants will appreciate moving into a home this tidy.” He waited for the girl to respond, but he saw that her face was tense, and she seemed unable to speak. “Well now, ” he said as cheerfully as he could, “we may as well go a little early. Let me help you with your things.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e330"
    }
  }, [_vm._v("“The box is in the bedroom, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e332"
    }
  }, [_vm._v("Howells went into the room and picked up the box, surprised at its weight. As he carried it out, he asked, “What do you have in here, Gervase?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e334"
    }
  }, [_vm._v("“All the things of my mother’s that I could keep. Some of her books and a few pictures and some of my things that I had when I was a little girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e336"
    }
  }, [_vm._v("“That’s very good. You sold everything else, I suppose?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e338"
    }
  }, [_vm._v("“I gave a lot of it away.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e340"
    }
  }, [_vm._v("“That’s a good child.” Howells went outside and loaded the heavy box into the buggy, then returned. Gervase was holding a rather large bag of some sort. “What is that, Gervase?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e342"
    }
  }, [_vm._v("“These are my clothes.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e344"
    }
  }, [_vm._v("“And this?” Howells motioned to a wicker basket.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e346"
    }
  }, [_vm._v("“That’s Mr. Bob.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e348"
    }
  }, [_vm._v("“Mr. Bob?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e351"
    }
  }, [_vm._v("“Yes sir, my cat.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e353"
    }
  }, [_vm._v("Howells appeared disturbed. “You’retaking your cat with you? I’m not sure that’s wise.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e355"
    }
  }, [_vm._v("Instantly Gervase drew up, her whole body taut. “Oh, sir, I have to take Mr. Bob with me! I’ve had him since he was a kitten.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e357"
    }
  }, [_vm._v("“Yes, child, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e359"
    }
  }, [_vm._v("“I’ve got to have him, sir! I won’tgo without him!” Gervase blinked rapidly several times and her voice was unsteady. “I found him when he was just a little kitten, four years ago. He would’ve died if it hadn’t been for me. I fed him with drops of milk and I can’t leave him here, sir!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e361"
    }
  }, [_vm._v("Reverend Howells suddenly felt a great compassion for this girl. “Well, I’m sure your uncle and aunt will understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e363"
    }
  }, [_vm._v("“I hope so, ” Gervase whispered, and then she looked the minister straight in the eye. “I won’t stay if they won’t let me keep Mr. Bob.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e365"
    }
  }, [_vm._v("Howells was taken somewhat aback by this defiant statement. He knew that the child was afraid, as any youngster would be under the circumstances, but there was a purpose in her he had not seen before. He cleared his throat. “Well, I will write them a letter and ask them to let you keep Mr. Bob.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e367"
    }
  }, [_vm._v("“Oh, thank you, Reverend!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e369"
    }
  }, [_vm._v("“There, there. Don’t let that be a bother to you.” Howells reached into his pocket and pulled out a small cloth purse.“This is a gift from some of the members of our congregation.” He extended the purse and when Gervase took it, he nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e371"
    }
  }, [_vm._v("“You might need a little extra.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e374"
    }
  }, [_vm._v("“I wish I could thank them, sir. Will you thank them for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e376"
    }
  }, [_vm._v("“Of course I will.” Howells hesitated, his rehearsed speech on the tip of his tongue, but somehow he felt it would not do. He cleared his throat and said briskly, “Well, are we ready to go?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e378"
    }
  }, [_vm._v("“Would you carry this, and I’ll bring Mr. Bob?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e380"
    }
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e382"
    }
  }, [_vm._v("Gervase handed over the sack containing her clothes and picked up the wicker basket. From inside came a plaintive meow and Gervase said, “It’s all right, Mr. Bob.” She walked outside and the minister accompanied her. He put the bag in the back of the buggy and asked, “Do you want me to put your cat beside us?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e384"
    }
  }, [_vm._v("“Yes, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e386"
    }
  }, [_vm._v("The minister took the wicker basket and his eyes widened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e388"
    }
  }, [_vm._v("“He is a heavy cat!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e390"
    }
  }, [_vm._v("“He weighs over a stone.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e392"
    }
  }, [_vm._v("“How did you figure that? You don’t have scales, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e394"
    }
  }, [_vm._v("“No, but we got flour in one-pound bags and I found stones that weighed the same. I put a board down and put him on one end and put the stones on the other until it balanced. He weighs sixteen pounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e397"
    }
  }, [_vm._v("“A fine animal, and I’m sure he will be a comfort to you.” The two got in the buggy and Howells picked up the reins. “All right, Geraldine, now you can go.” He slapped the lines on the back of the mare, who started out at a lively pace.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e399"
    }
  }, [_vm._v("As the buggy moved forward, Howells glanced at the girl, noting that her thin face was pale. She looked straight ahead for a time until they reached the top of the hill, and then she turned around. He had a full view of her face then. It was a good face, with a child’sim mature features. Her lips trembled but she said nothing. Finally she turned forward again, and he said cheerfully, “Now then. Have you ever ridden in a coach before?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e401"
    }
  }, [_vm._v("“No sir. I never have.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e403"
    }
  }, [_vm._v("“Well, it will be an experience for you. I think you’ll like it!”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "0310246997_content_0019_006",
      "id": "d12e405",
      "src": "images/0310246997_content_0019_006.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e406"
    }
  }, [_vm._v("As the wheels of the coach dropped into a pothole, all the passengers were jarred and thrown to the left. The coach had been practically empty when Gervase got on, but it had picked up passengers as they went along. It was the middle of May and hot and dusty so that perspiration ran down the faces of all the passengers. The coach seats had straight backs and no padding, making them uncomfortable. All morning long the coach had lurched over the rough road, picking up passengers and putting out a few, and eventually Gervase found herself sitting between a young man with a\n disagreeable countenance\n and a very large, rather silent man. She was holding Mr. Bob’s basket in her lap, and from time to time he would meow and she would open the lid enough to slide her hand in and caress his head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e408"
    }
  }, [_vm._v("“Coaches is for people, not for mangy cats, ” the young man said harshly. He had a dirty face and his clothes were rough. He was evidently a working man, rather short and skinny. His teeth were bad and his breath was terrible. “I can’t stand mangy cats!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e410"
    }
  }, [_vm._v("Gervase said nothing, for she was afraid. The other passengers seemed indifferent but the young man kept complaining.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e412"
    }
  }, [_vm._v("Finally the big man sitting on the other side of Gervase turned. He was well dressed and wore a gold ring with a green stone on his right forefinger. “You have your cat there, do you, miss?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e414"
    }
  }, [_vm._v("Gervase quickly glanced at him and saw that he was smiling at her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e416"
    }
  }, [_vm._v("“Yes sir, I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e419"
    }
  }, [_vm._v("“I’ve always liked cats myself. Look, now—you move over and take my seat by the window. Here, I’ll hold your cat while you do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e421"
    }
  }, [_vm._v("Gervase did not know what to do, but his smile encouraged her. She stood up and the big man moved to the center of the seat, holding the wicker basket high. “There you are, ” he said, giving it back to her after she sat again. “Now you can take him out of that box for a while and let him breathe some fresh air.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e423"
    }
  }, [_vm._v("“This ain’tno cat coach, ” the young man growled. “It’sfer people.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e425"
    }
  }, [_vm._v("The big man turned and leaned over, his weight crushing the smaller man. “You shut your mouth about this young lady’scat or I’ll throw you through the window!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e427"
    }
  }, [_vm._v("The young man looked up, ready to argue, but something he saw in the big man’s face caused him to reconsider. “None of my affair, ” he muttered sulkily and turned to stare out the window.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e429"
    }
  }, [_vm._v("“Right enough, ” the big man said. He turned to Gervase.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e431"
    }
  }, [_vm._v("“Now, take your cat out and let him look around. He’s been in that box all morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e433"
    }
  }, [_vm._v("“Will it be all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e435"
    }
  }, [_vm._v("“I say it will be.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e437"
    }
  }, [_vm._v("Gervase opened the lid and took Mr. Bob out. He stretched and sat in her lap and made no attempt to get away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e439"
    }
  }, [_vm._v("“Well, he’s a right good one, ain’the now?” the big man said. He reached over and stroked the cat’s head and asked, “What’s his name?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e442"
    }
  }, [_vm._v("“His name is Mr. Bob.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e444"
    }
  }, [_vm._v("“Well, Mr. Bob, let’s me and you make friends. We got a way to go before we get to London. . . .”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97ecfb10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Morr_ISBNXXXXXXXXX_epub_c6_r1.vue
// module id = 78
// module chunks = 0